let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("CYzZ6")).then(() => parcelRequire('6eaHY'));